module.exports = __webpack_public_path__ + "img/lemon-2.aa2ec863.png";